import { FC, lazy } from "react";
import { Route, Routes } from "react-router";
import { HomeLayout } from "./HomeLayout";
import { Home } from "./Home";

const AccountsAreaLazy = lazy(() => import("./Accounts/AccountsArea"));
const CreditCardsAreaLazy = lazy(() => import("./CreditCards/CreditCardsArea"));
const DebtForecastsAreaLazy = lazy(() => import("./DebtForecasts/DebtForecastsArea"));
const InvestmentsAreaLazy = lazy(() => import("./Investments/InvestmentsArea"));
const LoansAreaLazy = lazy(() => import("./Loans/LoansArea"));
const MortgagesAreaLazy = lazy(() => import("./Mortgages/MortgagesArea"));

export const HomeArea: FC = () => {
    return (
        <HomeLayout>
            <Routes>
                <Route index element={<Home />} />
                <Route path="accounts">
                    <Route index path="*" element={<AccountsAreaLazy />} />
                </Route>
                <Route path="creditcards">
                    <Route index path="*" element={<CreditCardsAreaLazy />} />
                </Route>
                <Route path="debtforecasts">
                    <Route index path="*" element={<DebtForecastsAreaLazy />} />
                </Route>
                <Route path="investments">
                    <Route index path="*" element={<InvestmentsAreaLazy />} />
                </Route>
                <Route path="loans">
                    <Route index path="*" element={<LoansAreaLazy />} />
                </Route>
                <Route path="mortgages">
                    <Route index path="*" element={<MortgagesAreaLazy />} />
                </Route>
            </Routes>
        </HomeLayout>
    );
};